const relatorios = angular.module('relatorios', [])

relatorios.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.relatorios',
            url: '/relatorios',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'relatorios.relatoriosComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);